import React from 'react';

const  Page404 = () => {

    return (
        <div className="not-found">
            <h1>Page 404 | Page Not Found</h1>
            <h3>Url/Page Yor are searching not found</h3>
        </div>
       
    )
}
export default Page404;